import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  HttpLoaderFactory,
  NavigationModule,
} from "../navigation/navigation.module";
import { ManageProfileRoutingModule } from "./manage-profile-routing.module";
import { ManageProfileComponent } from "./manage-profile.component";
import { AddProfileComponent } from "./add-profile/add-profile.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { WatchProfileComponent } from "./watch-profile/watch-profile.component";
import { FormsModule } from "@angular/forms";
import { NgxSpinnerModule } from "ngx-spinner";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";

@NgModule({
  declarations: [
    ManageProfileComponent,
    AddProfileComponent,
    EditProfileComponent,
    WatchProfileComponent,
  ],
  imports: [
    NavigationModule,
    CommonModule,
    ManageProfileRoutingModule,
    MatSlideToggleModule,
    FormsModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class ManageProfileModule {}
